import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import SelectUI from '../../../widgets/input/SelectUI.js'
import SwitchUI from '../../../widgets/action/SwitchUI.js'
import AllIncomeNavUI from '../../../components/superUser/loanList/AllIncomeNavUI.js'
import './TotalIncomePage.css'

const TotalIncomePageUI = ({ context, errorList, accountIncomeList, response, checked, onShowDetailsChange,
  onRefreshClick, financialYear, financialYearList, onFinancialYearChange }) =>
  <SuperUserHomePageUI context={context} className='pg_su_income' topnav='accounts'
    headerText='Incomes' centered={!accountIncomeList && !errorList} dimension='w1600'
    page='income'
  >
    {
      !accountIncomeList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      accountIncomeList &&
      <>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>Yearly Income</b></span>
            </span>
          }
          right={
            <span className='g_flex_h'>
              <span className='g_flex_h g_m_right_100'>
                <span className='g_muted g_small g_m_right_50'>
                  Loan breakup
                </span>
                <SwitchUI checked={checked} onChange={onShowDetailsChange} />
              </span>

              <span className='g_flex_h g_flex_right'>
                <SelectUI selectedKey={financialYear} optionList={financialYearList} onChange={onFinancialYearChange} placeholder='Financial year' />
              </span>
            </span>
          }
        />
        <div>
          <AllIncomeNavUI page='yearly' />
        </div>
      </>
    }
    {
      accountIncomeList && response &&
      <BigNumberUI response={response} />
    }
    {
      accountIncomeList && accountIncomeList.length !== 0 &&
      <AccountIncomeUI
        accountIncomeList={accountIncomeList}
        onRefreshClick={onRefreshClick}
        response={response}
        checked={checked}
      />
    }
    {
      accountIncomeList && accountIncomeList.length === 0 &&
      <div className='g_m_top_50'>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No data yet'
        />
      </div>
    }
  </SuperUserHomePageUI>

const BigNumberUI = ({ response }) =>
  <CardUI className='g_m_bottom_100'>
    <div className='g_flex_h'>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.interestPaidF4}</b></span>
          <span>Total Interest</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalPenaltyF4}</b></span>
          <span>Total Penalty</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.feePaidF4}</b></span>
          <span>Total Fee</span>
        </span>
      </div>
      <div>
        <span className='g_flex_v g_text_center'>
          <span className='g_xxxlarge'><b>{response.totalEarningsF4}</b></span>
          <span>Total Earned</span>
        </span>
      </div>
    </div>
  </CardUI>

const AccountIncomeUI = ({ accountIncomeList, response, checked }) =>
  <div>
    <CardUI className='g_m_top_100'>
      <table>
        <thead>
          <tr className='head g_sticky'>
            <td></td>
            <th className='g_p_left_100'>Account/Loan</th>
            <th className='g_p_left_100'>Interest Paid</th>
            <th className='g_p_left_100'>Penal Charge</th>
            <th className='g_p_left_100'>Dsra Dip Interest</th>
            <th className='g_p_left_100'>Processing Fee</th>
            <th className='g_p_left_100'>Application Fee</th>
            <th className='g_p_left_100'>Other Fee</th>
            <th className='g_p_left_100'>Total Earned</th>
          </tr>
        </thead>
        <tbody>
          {
            accountIncomeList.map((account, i) =>
              <>
                <tr className='acc' key={i}>
                  <td className='left'>{i + 1}.</td>
                  <td className='left g_no_wrap_2'>
                    <Link to={`/su/accounts/${account.accountId}/txns3`}>
                      {account.accountName}
                    </Link>
                  </td>
                  <td className='g_text_right amt'>{account.interestPaidF4}</td>
                  <td className='g_text_right amt'>{account.defaultIntPaidF4}</td>
                  <td className='g_text_right amt'>{account.dsraDipIntPaidF4}</td>
                  <td className='g_text_right amt'>{account.processFeeF4}</td>
                  <td className='g_text_right amt'>{account.loanAppliFeeF4}</td>
                  <td className='g_text_right amt'>{account.otherFeeF4}</td>
                  <td className='g_text_right amt'>{account.totalEarningsF4}</td>
                </tr>
                {
                  checked && account.loanIncomeList && account.loanIncomeList.map((loan, j) =>
                    <tr className='left g_muted' key={j}>
                      <td className='left'>{i + 1}.{j + 1}</td>
                      <td className='left g_no_wrap_2'>{loan.loanName}</td>
                      <td className='g_text_right amt'>{loan.interestPaidF4}</td>
                      <td className='g_text_right amt'>{loan.defaultIntPaidF4}</td>
                      <td className='g_text_right amt'>{loan.dsraDipIntPaidF4}</td>
                      <td className='g_text_right amt'>{loan.processFeeF4}</td>
                      <td className='g_text_right amt'>{loan.loanAppliFeeF4}</td>
                      <td className='g_text_right amt'>{loan.otherFeeF4}</td>
                      <td className='g_text_right amt'>{loan.totalEarningsF4}</td>
                    </tr>
                  )
                }
              </>
            )
          }
          <tr className='foot'>
            <td></td>
            <td className='left'><b>Total</b></td>
            <td className='g_text_right amt'><b>{response.interestPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.defaultIntPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.dsraDipIntPaidF4}</b></td>
            <td className='g_text_right amt'><b>{response.totalProcessFeeF4}</b></td>
            <td className='g_text_right amt'><b>{response.loanAppliFeeF4}</b></td>
            <td className='g_text_right amt'><b>{response.totalOtherFeeF4}</b></td>
            <td className='g_text_right amt'><b>{response.totalEarningsF4}</b></td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  </div>

export default TotalIncomePageUI
